// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Willy Woef",
    image: logoCT,
    route: "/",
  },
  socials: [],
  menus: [
    {
      name: "Contact",
      items: [{ name: "info@willywoef.nl", href: "mailto:info@willywoef.nl" }],
    },
    {
      name: "Voorwaarden",
      items: [
        { name: "algemene voorwaarden", href: "/algemene-voorwaarden" },
        { name: "privacybeleid", href: "/privacybeleid" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Alle rechten voorbehouden. Copyright &copy; {date} Willy Woef.
    </MKTypography>
  ),
};
